export default "__VITE_ASSET__Cu1MCLBF__"